const NAME_SEPARATOR = " || ";

function displayName(value) {
  if (!value) return "";
  const text = String(value);
  const index = text.indexOf(NAME_SEPARATOR);
  if (index === -1) return text;
  return text.slice(0, index).trim() || text.slice(index + NAME_SEPARATOR.length).trim();
}

export function caseStyleNameFromDetail(detail) {
  const raw = detail?.caseStyle?.name || detail?.caseStyleName || "";
  return displayName(raw);
}

export function formatPhoneWithCaseStyle(typeName, detailOrStyleName) {
  const style =
    typeof detailOrStyleName === "string"
      ? displayName(detailOrStyleName)
      : caseStyleNameFromDetail(detailOrStyleName);
  const type = typeName || "";
  if (!style) return type;
  return type ? `${type} · ${style}` : style;
}

const STYLE_MARK = " · ";

export const CASE_STYLE_FILTER_ALL = "all";
export const CASE_STYLE_FILTER_NORMAL = "normal";

export const BLACK_EDGE_SEND_MESSAGE =
  "الطلبات التي فيها حواف سوداء لا تُرسل إلى Girabatcom أو Printlet أو Printing Hold أو الإنتاج. الإنتاج الوحيد لها هو TeePlus.";

function styleText(name) {
  return displayName(name).trim().toLowerCase();
}

export function isTransparentCaseStyle(name) {
  const text = styleText(name);
  return text === "شفاف" || text.includes("transparent");
}

export function isBlackEdgeCaseStyle(name) {
  const text = styleText(name);
  return text.includes("حواف سوداء") || text.includes("black edge");
}

export function isSpecialCaseStyle(name) {
  const style = displayName(name).trim();
  if (!style) return false;
  return !isTransparentCaseStyle(style);
}

export function caseStyleFromItem(item) {
  if (!item) return "";
  if (item.caseStyleName) return displayName(item.caseStyleName);
  const type = String(item.type || "");
  const index = type.lastIndexOf(STYLE_MARK);
  if (index === -1) return "";
  return type.slice(index + STYLE_MARK.length).trim();
}

export function phoneTypeFromItem(item) {
  if (!item) return "";
  if (item.phoneType) return item.phoneType;
  const type = String(item.type || "");
  const style = caseStyleFromItem(item);
  const suffix = style ? `${STYLE_MARK}${style}` : "";
  if (suffix && type.endsWith(suffix)) return type.slice(0, -suffix.length);
  return type;
}

export function orderCaseStyles(order) {
  const names = [];
  const seen = new Set();
  for (const item of order?.items || []) {
    const style = caseStyleFromItem(item);
    if (!style || seen.has(style)) continue;
    seen.add(style);
    names.push(style);
  }
  return names;
}

export function orderHasBlackEdges(order) {
  return (order?.items || []).some((item) => isBlackEdgeCaseStyle(caseStyleFromItem(item)));
}

export function orderMatchesCaseStyleFilter(order, filter) {
  if (!filter || filter === CASE_STYLE_FILTER_ALL) return true;
  const specials = orderCaseStyles(order).filter(isSpecialCaseStyle);
  if (filter === CASE_STYLE_FILTER_NORMAL) return specials.length === 0;
  return specials.includes(filter);
}

export function specialCaseStyleLabels(catalogStyles, orders) {
  const labels = [];
  const seen = new Set();
  const add = (raw) => {
    const name = displayName(typeof raw === "string" ? raw : raw?.name || "");
    if (!isSpecialCaseStyle(name) || seen.has(name)) return;
    seen.add(name);
    labels.push(name);
  };
  for (const style of catalogStyles || []) add(style);
  for (const order of orders || []) {
    for (const name of orderCaseStyles(order)) add(name);
  }
  return labels;
}

export function teePlusPackedItemData(item) {
  const style = caseStyleFromItem(item);
  const phoneType = phoneTypeFromItem(item) || "Unknown Type";
  const type = isBlackEdgeCaseStyle(style) ? `Magic ${phoneType}` : phoneType;
  const driveLink = item?.driveLink || "No Link";
  const product = isBlackEdgeCaseStyle(style)
    ? "Magic Cover (H) + Packing"
    : "Phone Cover (H) + Packing";
  return `\t\t${product}\t${type}\t\t1\t${driveLink}`;
}
